import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import { useAddEncumbranceModal } from '../context/AddEncumbranceModalContext';

const AddEncumbranceModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddEncumbranceModal();

  const modalTitle =
    data.modalActionType === actionTypes.ADD
      ? t('AddEncumbrance')
      : t('EditEncumbrance');

  return (
    <Modal.Header>
      <h5 className="mb-0">{modalTitle}</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default AddEncumbranceModalHeader;
